/** Feature names listed in a comma-separated value, blanks dropped. */
export const parseFeatureList = (csv = '') =>
  new Set(
    csv
      .split(',')
      .map((name) => name.trim())
      .filter(Boolean),
  );

const disabled = parseFeatureList(import.meta.env.VITE_ADMIN_DISABLED_FEATURE);

/**
 * Whether `name` is left out of VITE_ADMIN_DISABLED_FEATURE. A plain function,
 * not a hook: route config and the sidebar's static arrays read it.
 */
export const isFeatureEnabled = (name: string) => !disabled.has(name);
